import { CreateNote } from '@/modules/notes/types';
import uuid from 'uuid/v4';

export const createNote = (conservatorship_id: string, note_id: string = uuid()): CreateNote => ({
  content: '',
  conservatorship_id,
  note_id
});
